<template>
  <img src="https://ysh-cdn.kaidicloud.com/test/coupon/guide-map.jpg" class="bg-img" />
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.bg-img {
  width: 100%;
}
</style>
